module.exports = __webpack_public_path__ + "static/media/CAM_H_05.30fc6e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/heads/CAM_H_05.png
// module id = 127
// module chunks = 0